import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  id: "container"
};
const _hoisted_2 = ["src"];
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';
import { onMounted, ref, watch } from 'vue';
import { useRoute } from 'vue-router';
export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const route = useRoute();
    const iframe = ref();
    NProgress.configure({
      showSpinner: false
    });
    watch(route, () => {
      load();
    });
    onMounted(() => {
      load();
      resize();
    });
    function show() {
      NProgress.start();
    }
    function hide() {
      NProgress.done();
    }
    function resize() {
      window.addEventListener('resize', () => {
        iframeInit();
      });
    }
    function load() {
      show();
      let time = 5;
      const timeFunc = setInterval(() => {
        time--;
        if (time === 0) {
          hide();
          clearInterval(timeFunc);
        }
      }, 1000);
      iframeInit();
    }
    function iframeInit() {
      if (!iframe.value) {
        return;
      }
      const clientHeight = document.documentElement.clientHeight - getOffsetHeight();
      iframe.value.style.height = `${clientHeight}px`;
      iframe.value.onload = () => {
        hide();
      };
    }
    function getOffsetHeight() {
      return document.getElementsByClassName('navbar')[0].clientHeight + document.getElementsByClassName('tags-view-container')[0].clientHeight + 6;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_unref(route).meta.url ? (_openBlock(), _createElementBlock("iframe", {
        key: 0,
        ref_key: "iframe",
        ref: iframe,
        src: _unref(route).meta.url,
        class: "iframe"
      }, null, 8, _hoisted_2)) : _createCommentVNode("", true)]);
    };
  }
});